import { Component, OnInit } from '@angular/core';
import { Observable } from 'src/app/classes/observable';
import { MfaService } from 'src/app/service/mfa.service';

@Component({
  selector: 'app-mfaactivate-component',
  templateUrl: './mfaactivate-component.component.html',
  styleUrls: ['./mfaactivate-component.component.scss'],
})

export class MfaactivateComponentComponent implements OnInit {

  public code;
  public codigoInvalido = false;
  public invalido = false;
  constructor(public MfaService:MfaService) { }

  ngOnInit() {}
  
  onChange(code) {
    this.code = code;
    this.invalido = false;
    this.codigoInvalido = false;
  }

  validarCodigo() {
    this.invalido=false;
    this.MfaService.activarMFA(this.code).then(data =>{
        Observable.notify("modalMFADismiss",true);
        Observable.notify("modalDismissMFA",true);
        
    }).catch(err => {
      this.codigoInvalido = true;
      this.invalido=true;
    });
  }

  volver() {
    Observable.notify("mfaQrVolver",true);
  }
}
